{
    "v": "4.8.0",
    "meta": { "g": "LottieFiles AE ", "a": "", "k": "", "d": "", "tc": "" },
    "fr": 30,
    "ip": 0,
    "op": 60,
    "w": 500,
    "h": 500,
    "nm": "35 Log Out",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 5,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Line",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [16.337, 0],
                                        [0, 0],
                                        [0, -16.054],
                                        [0, 0],
                                        [-16.336, 0],
                                        [0, 0],
                                        [0, 16.054],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, -16.054],
                                        [0, 0],
                                        [-16.336, 0],
                                        [0, 0],
                                        [0, 16.054],
                                        [0, 0],
                                        [16.337, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [23.727, -72.67],
                                        [23.727, -142.432],
                                        [-5.853, -171.5],
                                        [-141.92, -171.5],
                                        [-171.5, -142.432],
                                        [-171.5, 142.432],
                                        [-141.92, 171.5],
                                        [-5.853, 171.5],
                                        [23.727, 142.432],
                                        [23.727, 72.67]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.68], "y": [1] },
                                "o": { "x": [0.32], "y": [0] },
                                "t": 5,
                                "s": [0]
                            },
                            {
                                "i": { "x": [0.68], "y": [1] },
                                "o": { "x": [0.32], "y": [0] },
                                "t": 14,
                                "s": [21]
                            },
                            { "t": 22, "s": [0] }
                        ],
                        "ix": 1
                    },
                    "e": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.68], "y": [1] },
                                "o": { "x": [0.32], "y": [0] },
                                "t": 5,
                                "s": [100]
                            },
                            {
                                "i": { "x": [0.68], "y": [1] },
                                "o": { "x": [0.32], "y": [0] },
                                "t": 14,
                                "s": [79]
                            },
                            { "t": 22, "s": [100] }
                        ],
                        "ix": 2
                    },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Arrow 2",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.69, "y": 1 },
                            "o": { "x": 0.31, "y": 0 },
                            "t": 0,
                            "s": [221.5, 50, 0],
                            "to": [-15.333, 0, 0],
                            "ti": [-0.167, 0, 0]
                        },
                        {
                            "i": { "x": 0.69, "y": 1 },
                            "o": { "x": 0.31, "y": 0 },
                            "t": 14,
                            "s": [129.5, 50, 0],
                            "to": [0.167, 0, 0],
                            "ti": [-5.333, 0, 0]
                        },
                        {
                            "i": { "x": 0.69, "y": 1 },
                            "o": { "x": 0.31, "y": 0 },
                            "t": 22,
                            "s": [222.5, 50, 0],
                            "to": [5.333, 0, 0],
                            "ti": [-0.333, 0, 0]
                        },
                        {
                            "i": { "x": 0.69, "y": 1 },
                            "o": { "x": 0.31, "y": 0 },
                            "t": 27,
                            "s": [161.5, 50, 0],
                            "to": [0.333, 0, 0],
                            "ti": [-4.833, 0, 0]
                        },
                        {
                            "i": { "x": 0.69, "y": 1 },
                            "o": { "x": 0.31, "y": 0 },
                            "t": 32.818,
                            "s": [224.5, 50, 0],
                            "to": [4.833, 0, 0],
                            "ti": [0.5, 0, 0]
                        },
                        {
                            "i": { "x": 0.69, "y": 1 },
                            "o": { "x": 0.31, "y": 0 },
                            "t": 37.182,
                            "s": [190.5, 50, 0],
                            "to": [-0.5, 0, 0],
                            "ti": [-5.167, 0, 0]
                        },
                        { "t": 43, "s": [221.5, 50, 0] }
                    ],
                    "ix": 2
                },
                "a": { "a": 0, "k": [171.5, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [82.761, -87.203],
                                        [171.5, 0],
                                        [82.761, 87.204]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Line",
            "parent": 1,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [50, 50, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [171.5, 0],
                                        [-100.634, 0]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "tm",
                    "s": {
                        "a": 1,
                        "k": [
                            {
                                "i": { "x": [0.69], "y": [1] },
                                "o": { "x": [0.31], "y": [0] },
                                "t": 0,
                                "s": [0]
                            },
                            {
                                "i": { "x": [0.69], "y": [1] },
                                "o": { "x": [0.31], "y": [0] },
                                "t": 14,
                                "s": [41]
                            },
                            {
                                "i": { "x": [0.69], "y": [1] },
                                "o": { "x": [0.31], "y": [0] },
                                "t": 22,
                                "s": [0]
                            },
                            {
                                "i": { "x": [0.833], "y": [1] },
                                "o": { "x": [0.31], "y": [0] },
                                "t": 27,
                                "s": [25]
                            },
                            {
                                "i": { "x": [0.833], "y": [1] },
                                "o": { "x": [0.167], "y": [0] },
                                "t": 32.818,
                                "s": [0]
                            },
                            {
                                "i": { "x": [0.833], "y": [1] },
                                "o": { "x": [0.167], "y": [0] },
                                "t": 37.182,
                                "s": [13]
                            },
                            { "t": 43, "s": [0] }
                        ],
                        "ix": 1
                    },
                    "e": { "a": 0, "k": 100, "ix": 2 },
                    "o": { "a": 0, "k": 0, "ix": 3 },
                    "m": 1,
                    "ix": 2,
                    "nm": "Trim Paths 1",
                    "mn": "ADBE Vector Filter - Trim",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
            },
            "ao": 0,
            "ip": 0,
            "op": 60,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}
